module.exports = __webpack_public_path__ + "media/images/facebook-78704ef316ee9968e98cb96f61bfd525.svg";